export const LONG_UNIT_DISPLAY_ONLY_LOCALES = ['ja'];
